import { USER_LOGOUT, USER_LOGIN_SUCCESS, USER_INFOS_LOAD } from "./actions";

const initialState = {
  token:null,
  userinfos:{
    expirationtimestamp:''
  }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case USER_LOGIN_SUCCESS:
      return {
        ...state,
        token:action.payload.token_id,
        userinfos:action.payload.userinfos
      };
      break;
    case USER_INFOS_LOAD:
      return {
        ...state,
        userinfos:action.payload
      };
      break;
    case USER_LOGOUT:
      return {...initialState};
      break;
    default:
      return state;
  }
};
